import DefaultAnalyticsConfig from "../../../src/common/analytics/defaultAnalyticsConfig";

export default class AnalyticsConfig extends DefaultAnalyticsConfig {
  //overwrite configs if needed
  static gaTag = "UA-1529441-81";
  static CIMSchema = "iglu:com.twipemobile.article/context/jsonschema/1-0-0";
  static cmp = {
    hasPreferenceView: true,
    key: "97973d83-06d0-433f-8713-c4b550aa96e2",
    features: {
      GA: true,
      socialSharing: false,
    },
    GA: {
      vendorId: "c:googleana-K3miLnfY",
      purposeId: ["analyseco-VEg2eH3R"],
    },
  };
}



// WEBPACK FOOTER //
// ./clients/mfn-tij/js/analyticsConfig.js